module.exports = __webpack_public_path__ + "img/returnScan.c1b6325a.png";